export const INPUT_SIZE = 2;
export const ENTER = 'Enter';
